import { createContext } from "react";
import firebase from "firebase/app";

const FirebaseContext = createContext((null as unknown) as typeof firebase);

export default FirebaseContext;
